/**
 * @generated SignedSource<<d7fe50248b7229f6a8a9d6d069755a41>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type VerticalType = "furniture" | "fashion" | "jewelry" | "art" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenu_itemSearch$data = {
  readonly topCategoryL1: VerticalType | null;
  readonly pageType: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefineMenuFilters_itemSearch" | "SbSharedRefineMenuDisplayPrefsSelect_itemSearch" | "SbSharedRefineMenuSearchWithin_itemSearch">;
  readonly " $fragmentType": "SbRespRefineMenu_itemSearch";
};
export type SbRespRefineMenu_itemSearch$key = {
  readonly " $data"?: SbRespRefineMenu_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespRefineMenu_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespRefineMenu_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "topCategoryL1",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pageType",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilters_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuDisplayPrefsSelect_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuSearchWithin_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "842ac59f2d4db81c00aa800a241312c7";

export default node;
